module.exports = __webpack_public_path__ + "static/media/icons-ic-reschedule-demo-missed.d5c10fdc.svg";